import { createNavigation } from "next-intl/navigation"

import { staffRouting } from "@/i18n/routing"

export const { Link, getPathname, usePathname, useRouter } = createNavigation(staffRouting)
